import styled from "@emotion/styled";

export const StyledPromptContainer = styled.div`
  display: flex;
  align-items: flex-end;

  & > div:first-of-type {
    align-self: center;
  }

  .ql-align-left {
    text-align: left !important;
  }

  .ql-align-center {
    text-align: center !important;
  }

  .ql-align-right {
    text-align: right !important;
  }

  .ql-align-justify {
    text-align: justify !important;
  }

  .ql-font-sans-serif {
    font-family: "Your Sans Serif Font", sans-serif !important;
  }

  .ql-font-serif {
    font-family: "Your Serif Font", serif !important;
  }

  .ql-font-monospace {
    font-family: "Your Monospace Font", monospace !important;
  }
`;
